export const odemeSekliTypes = {
  ACIK_HESAP: "Açık Hesap",
  HAVALE: "Havale",
  KREDI_KARTI: "Kredi Kartı",
  NAKIT: "Nakit",
};
